export const rankOrderSuffix = (rankNum: number) => {
  // Rank number < 100:
  if (rankNum > 20) {
    const lastDigit = rankNum % 10
    switch (lastDigit) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  } else if (rankNum === 1) {
    return 'st'
  } else if (rankNum === 2) {
    return 'nd'
  } else if (rankNum === 3) {
    return 'rd'
  } else {
    return 'th'
  }
}
